import axios from "axios";
import {BASE_URL} from "../../constants/API";

export async function getRegulatoryDocumentsHeader() {
    return await axios.get(BASE_URL + '/regulatory-documents?populate=image');
}

export async function getRegulatoryDocuments() {
    return await axios.get(BASE_URL + '/regulatory-document-files');
}